import { TruckOutlined } from "@ant-design/icons";
import { Tag } from "antd";

export const DespachadoTag = ({ icon, text = null, ...restProps }) => {
  return (
    <Tag color="#1677FF" {...restProps}>
      {icon ? icon : <TruckOutlined />} {text === null ? "Despachado" : text}
    </Tag>
  );
};
